import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import { downloadArquivo } from '../arquivo/Actions.js';
import PageHeader from '../components/PageHeader.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import SubvencaoAnexos from '../subvencoes/FormDetalheAnexo.react.js';
import * as actions from './Actions.js';

export class AditivoDetalhe extends Component {
  static propTypes = {
    arquivos: PropTypes.object.isRequired,
    aditivo: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    findAditivo: PropTypes.func.isRequired,
    findArquivos: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { location, findAditivo, findArquivos } = this.props;

    const {
      entidade,
      exercicio,
      subvencao,
      anoSubvencao,
      numeroAditivo,
      anoAditivo
    } = getAllValuesFromUrlSearchParams(location);

    findAditivo(
      entidade,
      exercicio,
      subvencao,
      anoSubvencao,
      numeroAditivo,
      anoAditivo
    ).then(() => {
      findArquivos(
        entidade,
        exercicio,
        subvencao,
        anoSubvencao,
        numeroAditivo,
        anoAditivo
      );
    });
  }

  render() {
    const { aditivo, downloadArquivo, arquivos, location } = this.props;

    return (
      <div>
        <Helmet title={'Aditivo'} />

        <BotaoImprimir />

        <PageHeader location={location} />

        <CabecalhoEntidade />

        <Panel title={'Aditivo'}>
          <DisplayData border>
            <DisplayDataRow>
              <DisplayDataItem
                sm={2}
                title="Número"
                value={aditivo.get('numeroAditivo')}
                id="numeroAditivo"
              />
              <DisplayDataItem
                sm={2}
                title="Ano"
                value={aditivo.get('anoSubvencao')}
                id="anoSubvencao"
              />
              <DisplayDataItem
                sm={2}
                title="Tipo Aditivo"
                value={aditivo.get('tipo')}
                id="tipo"
              />
              <DisplayDataItem
                sm={3}
                title="Data Termo"
                value={DateUtils.transform(aditivo.get('dataTermo'))}
                id="dataTermo"
              />
              <DisplayDataItem
                sm={3}
                title="Data Fim Vigência"
                value={DateUtils.transform(aditivo.get('dataFimVigencia'))}
                id="dataFimVigencia"
              />
            </DisplayDataRow>
            <DisplayDataRow>
              <DisplayDataItem
                sm={4}
                title="Fornecedor"
                value={aditivo.get('nome')}
                id="nome"
              />
              <DisplayDataItem
                sm={2}
                title="Nº Diário"
                value={aditivo.get('numeroDiarioOficial')}
                id="numeroDiarioOficial"
              />
              <DisplayDataItem
                sm={3}
                title="Ano Diário"
                value={aditivo.get('anoDiarioOficial')}
                id="anoDiarioOficial"
              />
              <DisplayDataItem
                sm={3}
                title="Data Publicação"
                value={DateUtils.transform(aditivo.get('dataPublicacaoDiario'))}
                id="dataPublicacaoDiario"
              />
            </DisplayDataRow>
            <DisplayDataRow>
              <DisplayDataItem
                sm={6}
                title="Descrição"
                value={aditivo.get('descricao')}
                id="descricao"
              />
              <DisplayDataItem
                sm={3}
                title="Valor"
                value={NumberUtils.format(aditivo.get('valor'))}
                id="valor"
              />
              <DisplayDataItem
                sm={3}
                title="Valor Contrapartida"
                value={NumberUtils.format(aditivo.get('valorContraPartida'))}
                id="valorContraPartida"
              />
            </DisplayDataRow>
          </DisplayData>
        </Panel>

        <Panel isTable tableResponsive title="Anexos">
          <SubvencaoAnexos anexos={arquivos} onDownload={downloadArquivo} />
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    aditivo: state.aditivo.get('aditivo'),
    arquivos: state.aditivo.get('arquivos')
  };
}

const allActions = {
  ...actions,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(AditivoDetalhe);
